import React, { useEffect } from 'react';
import { NavMenu } from './SideNav';
import './MobileNavOverlay.css';

// DJB-122: mobile-only slide-in nav. The hamburger in the header opens it;
// the drawer eases in from the right over the page, showing the same NavMenu
// as the desktop rail (pages → sub-pages → sections plus the Dark Mode /
// Settings / user-card footer). It stays mounted so the close animation can
// play; while closed it is invisible (CSS) and aria-hidden. Closes on any
// navigation, the ✕ button, a backdrop tap, or Escape.
const MobileNavOverlay = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  return (
    <div
      className={`mobile-nav-overlay${open ? ' is-open' : ''}`}
      aria-hidden={!open}
    >
      <div className="mobile-nav-backdrop" onClick={onClose} />
      <nav className="mobile-nav-drawer" aria-label="Primary navigation">
        <div className="mobile-nav-drawer-header">
          {/* Decorative echo of the rail's brand row; the header already
              carries the accessible logo */}
          <img
            className="mobile-nav-drawer-logo"
            src="/DJ-logo-with-name.svg"
            alt=""
            aria-hidden="true"
          />
          <button
            type="button"
            className="mobile-nav-close"
            onClick={onClose}
            aria-label="Close navigation menu"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path
                d="M6 6l12 12M18 6L6 18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        <NavMenu onNavigate={onClose} />
      </nav>
    </div>
  );
};

export default MobileNavOverlay;
